import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private instance = 'ff';
  constructor() { }
  SanitizePath(path: string) {
    return path.split('/').filter(x => x).join('_')
  }
  sanitizeKinderaUrl(path: string) : string {
    return (path.includes('_') && !path.includes('[') )? `${path.replace('_', '[')}]` : path;
  }
  deleteFiltro(path: string, key: 'filtri' | 'ordinamento' = `filtri`) {
    localStorage.removeItem(this.getStorageKey(path, key))
  }
  deleteFiltri(path: string ) {
    const chiavi = Object.keys(localStorage).filter((chiave) => chiave.startsWith(this.getStorageKey(path, "filtri")))
    chiavi.forEach((chiave) => localStorage.removeItem(chiave))
    const chiavi2 = Object.keys(localStorage).filter((chiave) => chiave.startsWith(this.getStorageKey(path, 'ordinamento')))
    chiavi2.forEach((chiave) => localStorage.removeItem(chiave))
  }
  getFiltri(path: string, key:  'filtri' | 'ordinamento' = `filtri`) {
    const filledKeys = Object.keys(localStorage).filter((chiave) => chiave.startsWith(this.getStorageKey(path, key)));
    return filledKeys.map((chiave: string )=> {
      return {campo: this.formatChiave(chiave, key), value: JSON.parse(localStorage.getItem(chiave))};
    });
  }
  addFiltro(path: string, value: any, key:  'filtri' | 'ordinamento' = `filtri`) {
    localStorage.setItem(`${this.getStorageKey(this.sanitizeKinderaUrl(path), key)}`, JSON.stringify(value))
  }

  formatChiave(key: string, section:  'filtri' | 'ordinamento' = `filtri`) {
    if(key.includes(`_${section}_`) && key.includes(`[`) && key.includes(`]`))
      return  key.split(`_${section}_`)[1].split(`[`)[1].split(`]`)[0];
    if(key.includes(`_${section}_`) && key.includes(`_`) && !key.includes(`]`))
      return  key.split(`_`)[key.split(`_`).length -1];
    return key;
  }
  getStorageKey(path: string, section:  'filtri' | 'ordinamento' = `filtri`){
      return `${this.instance}_${section}_${this.SanitizePath(`${path}`)}`;
  }
  getObject(url: string, key: 'filtri'|'ordinamento' = 'filtri'){
    return this.getFiltri(url, key).reduce((acc, filtro) => {
      acc[filtro.campo] = filtro.value;
      return acc;
    }, {} as any);
  }
  setObject(url: string, object: any, section: 'filtri'|'ordinamento' = "filtri"){
    Object.getOwnPropertyNames(object).map((key) => {
      if(object[key] == undefined || object[key] == null) {
        this.deleteFiltro(`${url}[${key}]`, section)
        return;
      }
      this.addFiltro(`${url}[${key}]`, object[key], section)
    })
  }
}
